module.exports = __webpack_public_path__ + "static/media/cloud-transparent3.c76f4941.svg";